import React from 'react';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import classNames from 'classnames';

import { Bookset } from 'rebook/apps/catalog/models';
import AdaptiveImage from 'rebook/apps/utils/components/AdaptiveImage';
import Arrow from 'rebook/apps/dashboard/components/DashboardArrow';

import styles from './style.scss';


const DashboardSingleBookset = ({ blockTitle, bookset, halfWidth }) => {
  const theBookset = new Bookset(bookset);
  const booksetName = blockTitle || theBookset.name;

  const rubricsLength = get(theBookset, 'rubrics.length', 0);
  return (
    <div className={classNames(styles.container, { [styles.halfContainer]: halfWidth })}>
      <Link to={theBookset.getLink()} className={styles.wrapper}>
        <div className={styles.image}>
          {theBookset.picture || theBookset.preview
            ? (
              <AdaptiveImage
                src={{
                  url: theBookset.preview || theBookset.picture,
                  width: '568',
                  height: '240',
                }}
                srcSet={{
                  url: theBookset.preview || theBookset.picture,
                  width: '568',
                  height: '240',
                }}
                media="min-width: 414px"
                alt={booksetName} />
            )
            : <div className={styles.imageEmpty} />
          }
        </div>
        <div className={styles.content}>
          {rubricsLength > 0 && (
            <ul className={styles.rubrics}>
              {theBookset.rubrics.map((rubric, idx) => (
                <li className={styles.rubricsItem} key={`${theBookset.id}-${rubric.id}`}>
                  {rubric.name.trim()}{rubricsLength - 1 > idx && ', '}
                </li>
              ))}
            </ul>
          )}
          <h2 className="title-2">{booksetName}</h2>
          {theBookset.short_description && (
            <p>{theBookset.short_description}</p>
          )}
          <Arrow extraClassName={styles.arrow} />
        </div>
      </Link>
    </div>
  );
};

export default DashboardSingleBookset;
